import React, { useState } from "react";
import { FaUtensils } from "react-icons/fa";
import "./ProductImage.css";

/* Product photos live on local disk (MEDIA_ROOT) and can be missing
   or still uploading — render a neutral placeholder instead of a
   broken-image icon whenever the src is absent or fails to load. */
function ProductImage({ src, alt, className }) {
  const [failed, setFailed] = useState(false);
  // Portraits (taller than wide) get cropped into an unrecognizable
  // close-up by an object-fit: cover box sized for a landscape photo —
  // flag them via the image's actual pixel dimensions once loaded so
  // screens with a fixed-height image box (see ProductDetailScreen.css)
  // can letterbox them instead. Harmless everywhere else: without a
  // matching ".portrait" CSS rule, the class does nothing.
  const [portrait, setPortrait] = useState(false);

  if (!src || failed) {
    return (
      <div className={`product-image-placeholder ${className || ""}`}>
        <FaUtensils />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={`${className || ""}${portrait ? " portrait" : ""}`}
      onError={() => setFailed(true)}
      onLoad={(e) =>
        setPortrait(e.target.naturalHeight > e.target.naturalWidth)
      }
    />
  );
}

export default ProductImage;
